import './NewsTD.scss';
function NewsTD(props){
    const {news} = props;
    const imageurl = "https://img.freepik.com/free-vector/news-grunge-text_460848-9369.jpg";

    return (
        <>
            <div className="news-td" onClick={() => { window.location.href = "/article?id=" + news.id }}>
                <div className="news-td-image">
                    <img src={news.thumbnailUrl || imageurl} alt="News Thumbnail" />
                </div>
                <div className="news-td-title">
                    <p>{news.title}</p>
                </div>
            </div>
        </>
    )
}

export default NewsTD;